import { render, staticRenderFns } from "./ChecklistTimeStats.vue?vue&type=template&id=05f15395"
import script from "./ChecklistTimeStats.vue?vue&type=script&lang=js"
export * from "./ChecklistTimeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports